<template>
  <el-menu-item :index="menu.path || uniqueId">
    <i v-if="menu.icon" :class="` fa iconfont icon-${menu.icon}`"></i>
    <i v-if="menu.icon === undefined & !menu.iconSvg" class="fa fa-file-o"></i>
    <d2-icon-svg v-if="menu.iconSvg" :name="menu.iconSvg" />
    <span slot="title" ref="nav">{{menu.title || '未命名菜单'}}</span>
    <!-- 转办 -->
    <el-badge
      v-if="menu.id == '43f9ec66f37b4379959c9922c593692a'"
      :value="uncheck.sendHanding"
      :max="99"
      class="item noSee"
    ></el-badge>
    <!-- 交办 -->
    <el-badge
      v-if="menu.id == '2c2f4856779f4ac89ce831bddfb00c03'"
      :value="uncheck.takeHanding"
      :max="99"
      class="item noSee"
    ></el-badge>
    <!-- 未读 -->
    <el-badge v-if="menu.id == '1211'" :value="uncheck.handing" :max="99" class="item noSee"></el-badge>
  </el-menu-item>
</template>

<script>
import { uniqueId } from "lodash";
import { mapState } from "vuex";
export default {
  name: "d2-layout-header-aside-menu-item",
  props: {
    menu: {
      type: Object,
      required: false,
      default: () => {}
    }
  },
  computed: {
    ...mapState("d2admin/acceptLetter", ['uncheck'])
  },
  data() {
    return {
      uniqueId: uniqueId("d2-menu-empty-"),
    }
  },
};
</script>
<style scoped>
.noSee {
  position: absolute;
  right: 20px;
}
</style>

<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/layout/header-aside/components/components/menu-item/index.vue"
}
</vue-filename-injector>
